import { calculatePitchesForVibratoChange } from "@/components/pitchCorrection/vibratoKnob/calculatePitchesForVibratoChange";
import { Marker } from "@/types/defs/pitchCorrection/marker";

export const pitchDiffsFromSemitoneData = (
  pitches: number[],
  circles: Marker[]
) => {
  const vci = calculatePitchesForVibratoChange(100, 0, circles, pitches);
  return pitches.map((p, ix) => (p === 0 ? 0 : p - vci[ix]));
};
